import { useEffect } from 'react';
import { enableFullStory, disableFullStory } from 'utils/fullstoryUtils';

type Options = {
    enabled?: boolean;
    fingerprint?: string | null;
};

export function useFullStoryIdentity({ enabled, fingerprint }: Options) {
    useEffect(() => {
        if (!enabled) return;
        if (!fingerprint) return;

        enableFullStory(fingerprint);

        return () => {
            disableFullStory();
        };
    }, [enabled, fingerprint]);
}